import { render, staticRenderFns } from "./aftersale_image_material.vue?vue&type=template&id=c86f5db4&scoped=true"
import script from "./aftersale_image_material.vue?vue&type=script&lang=js"
export * from "./aftersale_image_material.vue?vue&type=script&lang=js"
import style0 from "./aftersale_image_material.vue?vue&type=style&index=0&id=c86f5db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f5db4",
  null
  
)

export default component.exports